import useDocumentHead from '../../utils/useDocumentHead';

const SEO = ({
  title = 'SmartLifeChoice - Your Journey to Health & Fitness',
  description = 'Evidence-based health and fitness articles, expert advice, and practical tips to help you achieve your wellness goals. Explore nutrition, workouts, mental health, and lifestyle guidance.',
  keywords = 'health, fitness, nutrition, wellness, mental health, workouts, weight loss, healthy lifestyle, intermittent fasting, exercise tips',
  author = 'SmartLifeChoice',
  image = 'https://smartlifechoice.co.uk/logo-og.png',
  url = 'https://smartlifechoice.co.uk',
  type = 'website',
  publishedTime,
  modifiedTime,
  article = false,
  category,
  tags = []
}) => {
  const siteUrl = 'https://smartlifechoice.co.uk';
  const canonicalUrl = url.startsWith('http') ? url : `${siteUrl}${url}`;
  const imageUrl = image.startsWith('http') ? image : `${siteUrl}${image}`;

  const metaTags = [
    { name: 'title', content: title },
    { name: 'description', content: description },
    { name: 'keywords', content: keywords },
    { name: 'author', content: author },
    { property: 'og:locale', content: 'en_GB' },
    { property: 'og:type', content: article ? 'article' : type },
    { property: 'og:url', content: canonicalUrl },
    { property: 'og:title', content: title },
    { property: 'og:description', content: description },
    { property: 'og:image', content: imageUrl },
    { property: 'og:image:width', content: '1200' },
    { property: 'og:image:height', content: '630' },
    { property: 'og:site_name', content: 'SmartLifeChoice' },
    { name: 'twitter:card', content: 'summary_large_image' },
    { name: 'twitter:url', content: canonicalUrl },
    { name: 'twitter:title', content: title },
    { name: 'twitter:description', content: description },
    { name: 'twitter:image', content: imageUrl },
    { name: 'twitter:creator', content: '@SmartLifeChoice' },
    { name: 'robots', content: 'index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1' },
    { name: 'googlebot', content: 'index, follow' },
    { name: 'bingbot', content: 'index, follow' },
    { name: 'viewport', content: 'width=device-width, initial-scale=1.0, maximum-scale=5.0' },
    { name: 'theme-color', content: '#2563eb' },
    { name: 'mobile-web-app-capable', content: 'yes' },
    { name: 'apple-mobile-web-app-capable', content: 'yes' },
    { name: 'apple-mobile-web-app-status-bar-style', content: 'default' },
    { name: 'geo.region', content: 'GB' },
    { name: 'geo.placename', content: 'United Kingdom' },
    { httpEquiv: 'Content-Language', content: 'en-GB' },
    { name: 'rating', content: 'general' },
    { name: 'distribution', content: 'global' },
  ];

  if (article) {
    metaTags.push({ property: 'article:author', content: author });

    if (publishedTime) {
      metaTags.push({ property: 'article:published_time', content: publishedTime });
    }

    if (modifiedTime) {
      metaTags.push({ property: 'article:modified_time', content: modifiedTime });
    }

    if (category) {
      metaTags.push({ property: 'article:section', content: category });
    }

    if (tags.length > 0) {
      tags.forEach((tag) => {
        metaTags.push({ property: 'article:tag', content: tag });
      });
    }
  }

  const linkTags = [
    { rel: 'canonical', href: canonicalUrl }
  ];

  const htmlAttributes = {
    lang: 'en-GB'
  };

  useDocumentHead({
    title,
    metaTags,
    linkTags,
    htmlAttributes
  });

  return null;
};

export default SEO;
